import React, { useEffect, useState } from 'react';
import { Plus, Check } from 'lucide-react';
import { getProducts } from '../lib/api';
import { useCart } from '../context/CartContext';

export const AddOns = ({ title = 'Add to your order', excludeId = null, excludeCode = null }) => {
  const { items, addToCart } = useCart();
  const [addons, setAddons] = useState([]);
  const [justAdded, setJustAdded] = useState(null);

  useEffect(() => {
    let active = true;
    getProducts()
      .then((all) => { if (active) setAddons((all || []).filter((p) => p.addon)); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const inCart = new Set(items.map((i) => i.id));
  const available = addons.filter((p) => !inCart.has(p.id) && p.id !== excludeId && p.code !== excludeCode);

  if (available.length === 0) return null;

  const add = (p) => {
    addToCart(p, 1);
    setJustAdded(p.id);
    setTimeout(() => setJustAdded((cur) => (cur === p.id ? null : cur)), 1200);
  };

  return (
    <div className="border border-alp-line rounded p-6 bg-alp-card/40" data-testid="addons-section">
      <h2 className="font-serif text-2xl text-alp-cream mb-1">{title}</h2>
      <p className="text-alp-gray text-xs mb-5">Every order already includes <span className="text-alp-cream">4 wipes + 4 syringes</span> free. Need more? Add the Sterile Essentials Kit &mdash; BAC water is additional.</p>
      <div className="space-y-3">
        {available.map((p) => (
          <div key={p.id} data-testid={`addon-${p.id}`} className="flex items-center gap-4 border border-alp-line/60 rounded p-3 bg-alp-dark/40">
            {p.image ? (
              <img src={p.image} alt={p.name} className="w-14 h-14 object-cover rounded bg-alp-dark shrink-0" />
            ) : (
              <div className="w-14 h-14 rounded bg-alp-dark shrink-0" />
            )}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <p className="text-alp-cream text-sm font-medium truncate">{p.name}</p>
                <span className="shrink-0 text-[9px] tracking-[0.12em] uppercase text-alp-gold border border-alp-gold/40 rounded-full px-2 py-0.5">Popular add-on</span>
              </div>
              <p className="text-alp-gray text-xs truncate">{[p.code, p.size].filter(Boolean).join(' \u00b7 ')}</p>
              <p className="text-alp-gold text-sm mt-0.5">${Number(p.price).toFixed(2)} AUD</p>
            </div>
            <button
              onClick={() => add(p)}
              data-testid={`addon-add-${p.id}`}
              className={`shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded text-xs tracking-[0.12em] uppercase font-semibold transition-colors ${justAdded === p.id ? 'bg-emerald-500/90 text-alp-black' : 'bg-alp-gold text-alp-black hover:bg-alp-goldlight'}`}
            >
              {justAdded === p.id ? (<><Check size={14} /> Added</>) : (<><Plus size={14} /> Add</>)}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
